export default {
  withdraw: {
    title: 'Rút tiền',
    subtitle: 'Nhanh chóng, an toàn và tiện lợi',
    secureEncrypted: 'An toàn và Mã hóa',
    fiatOrCash: 'Tiền pháp định/Tiền mặt',
    processing: 'Đang xử lý...',
    select: 'Chọn',
    withdrawCurrency: 'Tiền tệ rút',
    chooseNetwork: 'Chọn Mạng lưới',
    channel: 'Kênh',
    withdrawalAddress: 'Địa chỉ rút tiền',
    pixKeyType: 'Loại khóa PIX',
    accountNumber: 'Số tài khoản',
    enterAccountNumber: 'Vui lòng nhập số tài khoản của bạn',
    accountName: 'Tên tài khoản',
    enterAccountName: 'Vui lòng nhập tên chủ tài khoản',
    pixKey: 'Khóa PIX',
    enterPixKey: 'Vui lòng nhập khóa PIX của bạn',
    cpf: 'CPF',
    enterCpf: 'Vui lòng nhập CPF',
    bankName: 'Tên ngân hàng',
    enterBankName: 'Vui lòng nhập tên ngân hàng',
    branch: 'Chi nhánh',
    enterBranch: 'Vui lòng nhập chi nhánh (tùy chọn)',
    phone: 'Điện thoại',
    enterPhone: 'Vui lòng nhập số điện thoại (tùy chọn)',
    email: 'Email',
    enterEmail: 'Vui lòng nhập email (tùy chọn)',
    available: 'Có thể rút',
    amountPlaceholder: 'Số tiền ({unit})',
    min: 'Tối thiểu',
    max: 'Tối đa',
    totalWithdrawalAmount: 'Tổng số tiền rút:',
    fee: 'Phí:',
    withdrawalAmount: 'Số tiền rút:',
    fundsSafeTitle: 'Tiền của bạn được bảo vệ an toàn',
    fundsSafeDesc: 'Chúng tôi sử dụng bảo mật hàng đầu để bảo vệ giao dịch và thông tin cá nhân của bạn.',
    enterWithdrawalAddress: 'Vui lòng nhập địa chỉ rút tiền',
    enterAccountNumberRequired: 'Vui lòng nhập số tài khoản của bạn',
    selectChannelRequired: 'Vui lòng chọn kênh',
    enterAccountNameRequired: 'Vui lòng nhập tên chủ tài khoản',
    selectPixKeyTypeRequired: 'Vui lòng chọn loại khóa PIX',
    enterCpfRequired: 'Vui lòng nhập CPF',
    enterValidAmount: 'Vui lòng nhập số tiền hợp lệ',
    minWithdrawal: 'Rút tối thiểu: {amount} {unit}',
    maxWithdrawal: 'Rút tối đa: {amount} {unit}',
    insufficientBalance: 'Số dư khả dụng không đủ',
    withdrawalRejected: 'Yêu cầu rút tiền bị từ chối',
    submittedPendingReview: 'Đã gửi yêu cầu rút tiền, đang chờ duyệt',
    submittedPayoutInProgress: 'Đã gửi yêu cầu rút tiền, đang xử lý chi trả',
    withdrawalFailed: 'Rút tiền thất bại',
    withdrawalFailedRetry: 'Rút tiền thất bại, vui lòng thử lại',
  },
};
